export enum ProjTabType {
    All = 1,
    Shared = 2,
    Archived = 3,
    Trash = 4
}